/**
 * Tracking data for a content element as defined here https://github.com/secretescapes/front-end-tracking/blob/master/documentation/developer/event%20registry.md#content-rendered
 */
export interface IContentElementProps {
  elementType: ElementType;
  elementName: ElementName;
}

export enum ElementType {
  HOMEPAGE_PANEL = 'homepage panel',
  SEARCH_RESULTS = 'search results panel',
  EXPIRED_SALE = 'expired sale panel',
  ADVERTISEMENT_UNIT = 'ad unit',
  COLLECTION = 'collection results panel',
}

export enum ElementName {
  CURATED_COLLECTIONS = 'curated collections',
  MEDIUM_RECTANGLE = 'medium rectangle media banner',
  RECENTLY_VIEWED = 'recently viewed',
  RECOMMENDED_FOR_YOU = 'recommended for you',
  RECOMMENDED_FOR_YOU_FALLBACK = 'recommended for you fallback',
  TOP_DESTINATIONS = 'top destinations',
  MAP_VIEW_BUTTON = 'map view button',
  MAP_MARKER = 'map marker',
  MAP_SALE_CARD = 'map sale card',
  LIST_VIEW_BUTTON = 'list view button',
  SEARCH_RESULTS = 'search results',
  CURRENT_SALES = 'current sales',
  COLLECTION = 'collection',
  INFO_BANNER = 'info banner',
}

export enum InteractionType {
  CLICK = 'click',
}

interface ICollectionPanelDetails {
  listPosition: number;
  linkText: string;
}

interface ISaleCardDetails {
  listPosition: number;
  saleType: string;
  saleId: string;
}

export type RenderedItemDetailsType = ISalesWithId;

export type ItemDetailsType = ICollectionPanelDetails | ISaleCardDetails;

export interface ISaleWithId {
  saleId: string;
}

export interface ISalesWithId {
  sales: ISaleWithId[];
}

export interface IOtherMatches {
  elementName: string;
  sales: ISaleWithId[];
  numResults: number;
}

export interface ISaleListDisplayedDetails {
  numResults: number;
  searchParameters: ISearchParameters;
}

interface ISearchParameters {
  checkinDate: string;
  checkoutDate: string;
  isFlexibleSearch: boolean;
  location: string;
  searchByWeekendsOnly: boolean;
  travelTypes: string[];
  tripTypes: string[];
  months: string[];
  otherMatches: IOtherMatches[];
}

export enum ErrorKey {
  APP_DATA_LOAD = 'app data load error',
  BOOKINGS_PAGE_LOAD = 'booking page load error',
  BOOKING_DETAILS_LOAD = 'booking details page load error',
  CALENDAR_LOAD = 'calendar load error',
  CALENDAR_SELECTION_SUMMARY_LOAD = 'calendar selection summary load error',
  CANCELLATION_SUMMARY_LOAD = 'booking cancellation summary load error',
  CANCELLATION_CONFIRMATION = 'booking cancellation confirmation error',
  COLLECTION_INFO_LOAD = 'collection info load error',
  COLLECTION_PANEL_LOAD = 'collection panel load error',
  FAVOURITE_UPDATE = 'favourite update error',
  RECENTLY_VIEWED_LOAD = 'recently viewed load error',
  RECOMMENDED_FOR_YOU_LOAD = 'recommended for you load error',
  RECOMMENDED_SALES_LOAD = 'recommended sales load error',
  SALE_LIST_AD_LOAD = 'sale list ad load error',
  SALE_LIST_LOAD = 'sale list load error',
  SALE_MAP_LOAD = 'sale map error',
  SALE_LOAD = 'sale load error',
  USER_DATA_LOAD = 'user data load error',
  UPCOMING_SALE_LOAD = 'upcoming sale load error',
}

export enum ErrorType {
  LOADING_ERROR = 'loading error',
  MUTATION_ERROR = 'mutation error',
}
